import { Component } from "react";

type State = {
  hasError: boolean;
  error: Error | null;
};

export class ErrorBoundary extends Component<
  {
    fallback: (error: Error) => React.ReactNode;
    children: React.ReactNode;
  },
  State
> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Caught by ErrorBoundary::", error, info);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return this.props.fallback(this.state.error);
    }

    return this.props.children;
  }
}
